module.exports = __webpack_public_path__ + "static/media/import-finish.e24ed01c.svg";